import { useContext, useMemo } from 'react';
import _ from 'lodash';
import SingleUseMetricPopupContext from '../../../../../contexts/SingleUseMetricPopupContext';

const useEditingState = ({
  selectedMetric,
  metricDraft,
  invalidForm,
}: {
  selectedMetric?: Metrics.NormalMetric | Metrics.CompoundMetric;
  metricDraft?: Metrics.NormalMetric | Metrics.CompoundMetric;
  invalidForm?: boolean;
}): EditingState => {
  const { isSaveToDataManager, isSingleUsePopup } = useContext(
    SingleUseMetricPopupContext,
  );

  const state = useMemo((): EditingState => {
    if (!metricDraft || invalidForm) {
      return 'invalid form';
    }

    if (!selectedMetric) {
      return 'new metric';
    }

    if (isSingleUsePopup && isSaveToDataManager) {
      return 'has changes';
    }

    if (
      _.isEqual(selectedMetric, {
        ...metricDraft,
        updatedBy: selectedMetric.updatedBy,
        updatedOn: selectedMetric.updatedOn,
      })
    ) {
      if (selectedMetric.status === 'archived') {
        return 'no changes - archived';
      }

      return 'no changes';
    }

    if (selectedMetric.status === 'archived') {
      return 'has changes - archived';
    }

    return 'has changes';
  }, [
    invalidForm,
    isSaveToDataManager,
    isSingleUsePopup,
    metricDraft,
    selectedMetric,
  ]);

  return state;
};

export default useEditingState;
